import { useContext, useState } from "react";
import { UserContext } from "../components/context/UseContext";
import { useInfo } from "./useInfo";
import { useProfile } from "./settings/profile";
import axios from "./axios";
import { toast } from "sonner";
import { useLocation, useNavigate } from "react-router-dom";

export const useAuth = () => {
  const navigate = useNavigate();
  const search = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirm_password, setConfirmPassword] = useState("");
  const [referralCode, setReferralCode] = useState("");
  const [otp, setOtp] = useState("");
  const [show, setShow] = useState(false);
  const { setSignedUp, setToken } = useContext(UserContext);
  const { getuserInfo, loading, setLoading } = useInfo();
  const { getProfileInfo } = useProfile();

  const [signUp, setSignup] = useState({
    firstName: "",
    lastName: "",
    telephone: "",
    email: "",
    password: "",
    confirmPassword: "",
  });

  const [validateSignup, setValidateSignup] = useState({
    firstName: false,
    lastName: false,
    telephone: false,
    email: false,
    password: false,
    confirmPassword: false,
  });

  const handleSignUp = async () => {
    try {
      setLoading(true);
      const response = await axios.post(
        "/audiences/auth/register",
        referralCode
          ? JSON.stringify({
              email_or_phone: email,
              password: password,
              password_confirmation: confirm_password,
              referrer_id: referralCode,
            })
          : JSON.stringify({
              email_or_phone: email,
              password: password,
              password_confirmation: confirm_password,
            })
      );

      if (response.status === 201) {
        setToken(response.data.data.token);
        setSignedUp(true);
        getuserInfo(response.data.data.token, search?.search, true);
      }
    } catch (err) {
      setLoading(false);
      if (!err?.response) {
        toast.error(err.response.data.message);
      } else if (err.response?.status === 404) {
        toast.error(err.response.data.message);
      } else if (err.response?.status === 422) {
        toast.error(err.response.data.message);
      } else {
        toast.error("Registration Failed, please try again");
      }
    }
  };

  const handleCheckAudience = async () => {
    try {
      setLoading(true);
      const response = await axios.post(
        "/audiences/check-audience",
        JSON.stringify({
          email_or_phone: email,
        })
      );

      if (response.status === 200) {
        setLoading(false);
        if (response.data.message) {
          setShow(true);
        } else {
          navigate(
            `/verify-otp${
              search?.search ? `${search?.search}&` : "?"
            }mobile=${encodeURIComponent(email)}`
          );
        }
      }
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  };

  const handleResendOtp = async () => {
    try {
      setLoading(true);
      const response = await axios.post(
        "/audiences/check-audience",
        JSON.stringify({
          email_or_phone: email,
        })
      );

      if (response.status === 200) {
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  };

  const handleSignIn = async () => {
    try {
      setLoading(true);
      const response = await axios.post(
        "/audiences/auth/login",
        JSON.stringify({
          email_or_phone: email,
          password: password,
        })
      );

      if (response.status === 200) {
        setToken(response.data.data.token);
        setSignedUp(false);
        getuserInfo(response.data.data.token, search?.search, true);
        getProfileInfo(response.data.data.token, true);
      }
    } catch (err) {
      setLoading(false);
      if (!err?.response) {
        toast.error(err.response.data.message);
      } else if (err.response?.status === 404) {
        toast.error(err.response.data.message);
      } else if (err.response?.status === 401) {
        toast.error(err.response.data.message);
      } else {
        toast.error("Login Failed");
      }
    }
  };

  const handleVerifyOtp = async () => {
    try {
      setLoading(true);
      const response = await axios.post(
        "/auth/verify-otp",
        JSON.stringify({
          email_or_phone_no: email,
          otp: otp,
        })
      );

      if (response.status === 200) {
        navigate(`/setup-password${search?.search}`);
      }
    } catch (err) {
      setLoading(false);
      if (!err?.response) {
        toast.error(err.response.data.message);
      } else if (err.response?.status === 404) {
        toast.error(err.response.data.message);
      } else if (err.response?.status === 401) {
        toast.error(err.response.data.message);
      } else {
        toast.error("Otp verification failed");
      }
    }
  };

  return {
    handleSignUp,
    handleCheckAudience,
    handleResendOtp,
    signUp,
    setSignup,
    validateSignup,
    setValidateSignup,
    handleSignIn,
    email,
    setEmail,
    password,
    setPassword,
    loading,
    show,
    setShow,
    handleVerifyOtp,
    otp,
    setOtp,
    confirm_password,
    setConfirmPassword,
    referralCode,
    setReferralCode,
  };
};
